import React from 'react';
import { SpriteSvg } from 'project/sprite-svg';

const LeaderboardFeaturedGroupLive = ({ targetUrl }) => {
    if (!targetUrl) return null;

    return (
        <a
            className="leaderboard__featured-group-live"
            href={targetUrl}>
            <div className="leaderboard__featured-group-live-text">
                Featured group
            </div>
            <div className="leaderboard__featured-group-live-icon-wrapper">
                <SpriteSvg
                    childCss="leaderboard__featured-group-live-icon"
                    iconName="watch"
                    width="14"
                    height="14"
                />
            </div>
        </a>
    );
};

export default LeaderboardFeaturedGroupLive;
